import { FeatureAppNames } from './app-constants';
import { createMofaConfig } from './create-mofa-config';
import { ModelOverviewIntegratorOptions } from './create-options-from-query-params';
import { defaultAppConfig } from './default-app-config';

const getCreateFunctionInstance = (featureAppName: string | undefined) => {
  switch (featureAppName) {
    case FeatureAppNames.DEFAULT as string:
      return defaultAppConfig.createFunctionInstance;
    default:
      return createMofaConfig;
  }
};

export const getConfigsFeatureApp = ({
  featureAppName,
  ...props
}: ModelOverviewIntegratorOptions) => {
  const createFunctionInstance = getCreateFunctionInstance(featureAppName);
  return createFunctionInstance(props);
};

export const contentFeatureAppMap = {
  [FeatureAppNames.DEFAULT]: defaultAppConfig.appContent,
};
